module.exports = __webpack_public_path__ + "img/gbwhatsapp-app-info.b3bed050.webp";